import { emitFlagMessage } from '@cae/cobalt-react/components/flag-message';
import * as React from 'react';

import type {
  DownloadDocumentParams,
  DownloadDocumentResult,
} from '../../api/download-document/downloadDocument.types';
import type { UseDownloadDocumentReturn } from './useDownloadDocument.types';

import { downloadDocument } from '../../api/download-document/downloadDocument';

export function useDownloadDocument(): UseDownloadDocumentReturn {
  const [downloadingIds, setDownloadingIds] = React.useState<Set<string>>(
    () => new Set()
  );

  const download = React.useCallback(
    (documentId: string, organizationId?: string): void => {
      setDownloadingIds(prev => new Set(prev).add(documentId));

      const params: DownloadDocumentParams = { documentId, organizationId };

      downloadDocument(params)
        .then(({ blob, filename }: DownloadDocumentResult): void => {
          const url = URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          if (filename) {
            anchor.download = filename;
          }
          anchor.click();
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        })
        .catch((error: unknown): void => {
          console.error('Document download failed:', error);
          emitFlagMessage(
            'danger',
            'Downloading the document failed, please try again.',
            5000
          );
        })
        .finally((): void => {
          setDownloadingIds(prev => {
            const next = new Set(prev);
            next.delete(documentId);
            return next;
          });
        });
    },
    []
  );

  const isDocumentDownloading = React.useCallback(
    (documentId: string): boolean => downloadingIds.has(documentId),
    [downloadingIds]
  );

  return {
    download,
    isDocumentDownloading,
  };
}
